import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import MemberLogin from "@/pages/MemberLogin";
import MemberDashboard from "@/pages/MemberDashboard";
import LicenseTerms from "@/pages/LicenseTerms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/login" element={<MemberLogin />} />
          <Route path="/dashboard" element={<MemberDashboard />} />
          <Route path="/license-terms" element={<LicenseTerms />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-center" richColors />
    </div>
  );
}

export default App;
